module.exports = __webpack_public_path__ + "static/media/1.a23afde0.jpg";